import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { PermissionService } from '@core/services/permission.service';
import { ToastService } from '@core/services/toast.service';
import { Observable, tap } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard  {
  constructor(private router: Router, private permissionService: PermissionService, private authService: AuthService, private toast: ToastService, private translocoService: TranslocoService) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let isValid = true;

    if (route.data) {

      var permissions = route.data['permission'];

      if (Array.isArray(permissions)) {
        for (let permission of permissions)
        {
          isValid = this.permissionService.checkPermission(permission);
          if(isValid) break;
        }
      } else {
        isValid = this.permissionService.checkPermission(permissions);
      }


      if (!isValid) {
        this.router.navigateByUrl('dashboard');
        this.toast.error(this.translocoService.translate('shared.messages.notAuthorizedForPage'));
      }
    }
    return isValid;
  }

}
